import { useReducer } from "react";

// Note: React calls the reducer twice, so the console log repeats
// https://github.com/facebook/react/issues/16295#issuecomment-610098654

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_PERSONA":
      return {
        ...state,
        persona: action.values.persona,
      };
    case "SET_CONNECTION":
      if (state.connected === action.values.connected) {
        console.log("SET_CONNECTION do nothing");
        return state;
      } else {
        console.log("SET_CONNECTION: ", action.values.connected);
        return {
          ...state,
          connected: action.values.connected,
        };
      }
    case "SET_AUTH":
      console.log("Set auth");
      if (state.authenticated === action.values.authenticated) {
        console.log("SET_AUTH do nothing");
        return state;
      } else {
        console.log("SET_AUTH: ", action.values.authenticated);
        return {
          ...state,
          authenticated: action.values.authenticated,
        };
      }
    case "LOGIN":
      console.log("Logging in...", action.values);
      return {
        ...state,
        uid: action.values.uid,
        password: action.values.password,
        muid: action.values.muid,
        cid: action.values.cid,
        isLoggedIn: true,
      };
    case "SET_CURRENT_TOPIC":
      return {
        ...state,
        displaying_topic: action.values.displaying_topic,
      };
    case "SET_MUID":
      console.log("Setting state muid: ", action.values.muid);
      return {
        ...state,
        muid: action.values.muid,
      };
    case "LOGOUT":
      console.log("Logging out...");
      return {
        ...state,
        uid: "",
        muid: "",
        isLoggedIn: false,
      };
    case "setState":
      const newState = {
        ...state,
        ...action.values,
      };
      console.log("newState: ", newState);
      return newState;
    default: {
      console.log("Logging default...");
      return state;
    }
  }
};

const useGlobalState = (state) => {
  const [globalState, globalDispatch] = useReducer(reducer, state);
  return { globalState, globalDispatch };
};

export default useGlobalState;
